import classNames from 'classnames';
import styles from './BlockContainer.module.scss';

const BlockHeader = ({ children, className, style, priority, stickyTop, boldHeading, ...props }) => {
  const HeaderTag = priority ? `h${priority}` : 'div';

  return (
    <HeaderTag
      {...props}
      className={classNames(
        styles['block-container__header'],
        { [styles['bold-heading']]: boldHeading, [styles['sticky']]: stickyTop != null },
        className,
      )}
      style={{ ...style, ...(stickyTop != null ? { top: stickyTop } : { position: 'block' }) }}
    >
      {children}
    </HeaderTag>
  );
};
export { BlockHeader as default, BlockHeader };
